// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { sprintf } from 'sprintf-js';
import { trackClicked } from 'utils/analytics';
import { LISTING_TYPE_HUMAN_NAME_MAP } from 'utils/constants';
import type { Dispatch, State } from '../redux/main';
import {
  saveListing as saveListingAction,
  unsaveListing as unsaveListingAction
} from '../redux/main/actions/currentUser';
import { showModal } from '../redux/main/actions/modal';

type OwnProps = {|
  listingId: string,
  listingType: string,
  listingName: string,
  listingId: string,
  orgId?: ?string,
  orgType?: ?string,
  groupId?: ?string,
  render: ({
    saveListing: () => void,
    unsaveListing: () => void,
    saved: boolean,
    canSave: boolean
  }) => React.Node
|};

type Props = {
  ...$Exact<OwnProps>,
  loggedIn: boolean,
  saved: boolean,
  canSave: boolean,
  saveListing: () => void,
  unsaveListing: () => void,
  showEmailSignupModal: () => void
};

const SaveListingContainer = ({
  loggedIn,
  listingId,
  listingType,
  orgId,
  orgType,
  groupId,
  saved,
  canSave,
  saveListing,
  unsaveListing,
  showEmailSignupModal,
  render
}: Props) => {
  const save = () => {
    if (loggedIn) {
      saveListing();
    } else {
      showEmailSignupModal();
    }
    trackClicked('Save Listing', {
      listing_type: LISTING_TYPE_HUMAN_NAME_MAP[listingType],
      listing_id: listingId,
      org_id: orgId,
      org_type: orgType,
      group_id: groupId
    });
  };
  return render({
    saved,
    canSave,
    saveListing: save,
    unsaveListing
  });
};

const mapStateToProps = (
  { currentUser }: State,
  { listingId }: { listingId: string }
) => ({
  currentUser,
  saved:
    currentUser.isLoaded &&
    currentUser.savedListings !== undefined &&
    currentUser.savedListings.find(listing => listing.id === listingId) !==
      undefined,
  canSave: currentUser.isLoaded,
  loggedIn: !!currentUser.id
});

const mapDispatchToProps = (
  dispatch: Dispatch,
  {
    listingId,
    listingType,
    listingName
  }: { listingId: string, listingType: string, listingName: string }
) => ({
  saveListing: () =>
    dispatch(saveListingAction(listingId, listingType, listingName)),
  showEmailSignupModal: () =>
    dispatch(
      showModal('EMAIL_SIGNUP', {
        title: sprintf(getText('Save this %(listingType)s'), {
          listingType: LISTING_TYPE_HUMAN_NAME_MAP[listingType]
        }),
        savedListing: {
          id: listingId,
          type: listingType,
          name: listingName
        },
        signupEmailParams: {
          listing: {
            id: listingId,
            type: listingType
          }
        }
      })
    ),
  unsaveListing: () =>
    dispatch(unsaveListingAction(listingId, listingType, listingName))
});

export default connect<Props, OwnProps, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(SaveListingContainer);
